(ns machtfit.startpage.icons)

(defn dropdown []
  [:svg
   {:viewBox "-295.3 420.3 8.7 4.9", :height "4.9", :width "8.7"}
   [:path
    {:d
     "M-291.04 424.16l3.5-3.5c.1-.1.4-.1.5 0 .1.1.1.4 0 .5l-3.8
     3.7c-.1.1-.4.1-.5 0l-3.7-3.7c-.1-.1-.1-.4 0-.5.1-.1.4-.1.5 0l3.5 3.5z"
     :fill "#1D2727"}]
   [:path
    {:d
     "M-291.04 424.16l3.5-3.5c.1-.1.4-.1.5 0 .1.1.1.4 0 .5l-3.8
     3.7c-.1.1-.4.1-.5 0l-3.7-3.7c-.1-.1-.1-.4 0-.5.1-.1.4-.1.5 0l3.5 3.5z"
     :stroke-miterlimit "50"
     :stroke-width ".5"
     :stroke "#1D2727"
     :fill "none"}]])

(defn content-loader []
  [:svg {:width "364px", :height "633px", :viewBox "0 0 364 633", :version "1.1"}
   [:g {:stroke "none", :stroke-width "1", :fill "none", :fill-rule "evenodd"}
    [:g {:fill "#D5DADC"}
     [:path {:d "M71.9548336,253 C71.9848,252.503839 72,252.003695 72,251.5
     C72,237.969024 61.0309764,227 47.5,227 C33.9690236,227 23,237.969024
     23,251.5 C23,252.003695 23.0152,252.503839 23.0451664,253 L0,253 L0,4
     C-2.705415e-16,1.790861 1.790861,4.05812251e-16 4,0 L360,-4.4408921e-16
     C362.209139,-8.49901461e-16 364,1.790861 364,4 L364,253 L71.9548336,253
     Z"}]]
    [:rect {:fill "#D5DADC", :x "21", :y "282", :width "113", :height "18", :rx "9"}]
    [:rect {:fill "#D5DADC", :x "21", :y "397", :width "113", :height "18", :rx "9"}]
    [:rect {:fill "#D5DADC", :x "21", :y "431", :width "173", :height "18", :rx "9"}]
    [:rect {:fill "#D5DADC", :x "21", :y "465", :width "204", :height "18", :rx "9"}]
    [:rect {:fill "#D5DADC", :x "21", :y "499", :width "161", :height "18", :rx "9"}]
    [:rect {:fill "#D5DADC", :x "21", :y "316", :width "248", :height "25", :rx "12.5"}]
    [:rect {:fill "#D5DADC", :x "21", :y "572", :width "323", :height "25", :rx "12.5"}]]])

#_{:clj-kondo/ignore [:clojure-lsp/unused-public-var]}
(defn online []
  [:svg
   {:version "1.1", :viewBox "0 0 30 30", :height "30px", :width "30px"}
   [:g
    {:fill-rule "evenodd"
     :fill "none"
     :stroke-width "1"
     :stroke "none"}
    [:g
     {:fill-rule "nonzero"
      :fill "#000000"
      :transform "translate(5.000000, 0.000000)"}
     [:path
      {:d
       "M15.89,0 L3.89,0 C2.24,0 0.89,1.35 0.89,3 L0.89,27 C0.89,28.65 2.24,30
       3.89,30 L15.89,30 C17.54,30 18.89,28.65 18.89,27 L18.89,3 C18.89,1.35
       17.55,0 15.89,0 Z M17.69,27 C17.69,27.99 16.88,28.8 15.89,28.8 L3.89,28.8
       C2.9,28.8 2.09,27.99 2.09,27 L2.09,3 C2.09,2.01 2.9,1.2 3.89,1.2
       L15.89,1.2 C16.88,1.2 17.69,2.01 17.69,3 L17.69,27 L17.69,27 Z"}]
     [:path
      {:d
       "M11.09,2.4 L8.69,2.4 C8.36,2.4 8.09,2.67 8.09,3 C8.09,3.33 8.36,3.6
       8.69,3.6 L11.09,3.6 C11.42,3.6 11.69,3.33 11.69,3 C11.69,2.67 11.42,2.4
       11.09,2.4 Z"}]
     [:path
      {:d
       "M9.89,26.4 C9.56,26.4 9.29,26.67 9.29,27 C9.29,27.33 9.56,27.6 9.89,27.6
       C10.22,27.6 10.49,27.33 10.49,27 C10.49,26.67 10.22,26.4 9.89,26.4 Z"}]
     [:path
      {:d
       "M18.29,4.8 L1.49,4.8 C1.16,4.8 0.89,5.07 0.89,5.4 C0.89,5.73 1.16,6
       1.49,6 L18.29,6 C18.62,6 18.89,5.73 18.89,5.4 C18.89,5.07 18.62,4.8
       18.29,4.8 Z"}]
     [:path
      {:d
       "M18.29,24 L1.49,24 C1.16,24 0.89,24.27 0.89,24.6 C0.89,24.93 1.16,25.2
       1.49,25.2 L18.29,25.2 C18.62,25.2 18.89,24.93 18.89,24.6 C18.89,24.27
       18.62,24 18.29,24 Z"}]]]])

#_{:clj-kondo/ignore [:clojure-lsp/unused-public-var]}
(defn travel []
  [:svg
   {:version "1.1", :viewBox "0 0 30 30", :height "30px", :width "30px"}
   [:g
    {:fill-rule "evenodd"
     :fill "none"
     :stroke-width "1"
     :stroke "none"}
    [:g
     {:fill-rule "nonzero", :fill "#000000"}
     [:path
      {:d
       "M6.05,24.38 C8.66,19.83 10.3,14.79 10.86,9.58 L15.51,14.2 C15.6,14.29
       15.73,14.34 15.86,14.35 C15.89,14.35 15.91,14.35 15.94,14.34 C16.1,14.31
       16.23,14.21 16.31,14.07 C17.25,12.19 16.88,9.91 15.39,8.43 L14.98,8.02
       L18.5,8.02 C18.78,8.02 19,7.8 19,7.52 C19,7.47 18.99,7.41 18.97,7.36
       C18.31,5.36 16.44,4.02 14.33,4.02 L13.68,4.02 L16.18,1.51 C16.37,1.31
       16.37,1 16.18,0.8 C16.14,0.76 16.1,0.73 16.05,0.71 C14.17,-0.23
       11.89,0.14 10.41,1.63 L9.94,2.1 C9.78,2.26 9.64,2.42 9.5,2.6 C9.37,2.42
       9.23,2.26 9.07,2.1 L8.6,1.62 C7.11,0.13 4.84,-0.24 2.95,0.71 C2.71,0.83
       2.61,1.13 2.73,1.38 C2.75,1.43 2.79,1.47 2.82,1.51 L5.32,4.02 L4.67,4.02
       C2.57,4.02 0.7,5.36 0.03,7.36 C-0.06,7.62 0.08,7.91 0.35,7.99 C0.4,8.01
       0.45,8.02 0.51,8.02 L4.02,8.02 L3.61,8.43 C2.12,9.92 1.75,12.19
       2.69,14.07 C2.76,14.21 2.9,14.31 3.06,14.34 C3.09,14.34 3.11,14.35
       3.14,14.35 C3.27,14.35 3.4,14.3 3.49,14.2 L7.82,9.9 C7.28,14.69
       5.48,19.25 2.59,23.11 C1.92,22.93 1.24,22.79 0.55,22.69 L0.24,22.66
       L0.14,23.66 L0.43,23.69 C0.93,23.76 1.43,23.86 1.92,23.98 C1.82,24.11
       1.72,24.23 1.62,24.36 L2.39,25 C6.23,20.43 8.52,14.76 8.93,8.8 L9.5,8.22
       L9.93,8.65 C9.41,15.02 7.22,21.14 3.6,26.4 L4.42,26.97 C4.81,26.41
       5.19,25.83 5.55,25.23 C7.89,26.35 9.95,27.97 11.6,29.97 L12.37,29.34
       C11.4,28.16 10.28,27.1 9.05,26.19 L30,26.19 L30,25.19 L7.57,25.19
       C7.08,24.89 6.57,24.63 6.05,24.38 Z M15.68,12.95 L10.4,7.7 C11.75,7.3
       13.21,7.66 14.22,8.65 L14.7,9.13 C15.69,10.13 16.07,11.6 15.68,12.95 Z
       M17.74,7.02 L13.6,7.02 C12.64,6.56 11.55,6.43 10.5,6.65 C11.23,5.63
       12.41,5.02 13.66,5.02 L14.33,5.02 C15.75,5.02 17.06,5.78 17.74,7.02 Z
       M10.64,2.81 L11.12,2.33 C12.12,1.33 13.58,0.95 14.94,1.34 L11.98,4.32
       C11.02,4.67 10.19,5.32 9.62,6.17 C9.38,4.95 9.77,3.69 10.64,2.81
       L10.64,2.81 Z M7.89,2.33 L8.37,2.81 C8.59,3.04 8.79,3.29 8.95,3.57
       C8.71,4.09 8.58,4.65 8.56,5.23 C8.11,4.84 7.59,4.53 7.04,4.33 L4.07,1.34
       C5.43,0.95 6.89,1.33 7.89,2.33 L7.89,2.33 Z M4.67,5.02 L5.35,5.02
       C6.61,5.02 7.79,5.63 8.51,6.65 C7.47,6.43 6.38,6.56 5.41,7.02 L1.27,7.02
       C1.95,5.78 3.25,5.02 4.67,5.02 L4.67,5.02 Z M3.33,12.95 C2.94,11.59
       3.32,10.13 4.32,9.13 L4.8,8.65 C5.51,7.94 6.49,7.54 7.5,7.54 C7.87,7.54
       8.25,7.59 8.61,7.7 L3.33,12.95 Z"}]]]])

(defn arrow-right []
  [:svg
   {:version "1.1", :viewBox "0 0 10 19", :height "19px", :width "10px"}
   [:g
    {:fill-rule "evenodd"
     :fill "none"
     :stroke-width "1"
     :stroke "none"}
    [:g
     {:fill-rule "nonzero"
      :fill "#000000"
      :transform "translate(-644.000000, -439.000000)"}
     [:g
      {:transform "translate(633.000000, 431.000000)"}
      [:g
       {:transform "translate(11.000000, 8.000000)"}
       [:path
        {:transform
         "translate(5.000000, 9.500000) scale(-1, 1) translate(-5.000000, -9.500000) "
         :d
         "M1.29585564,9.49950228 L9.84235574,0.918792896 C10.0525481,0.707759208
         10.0525481,0.369308954 9.84235574,0.158275266 C9.63216339,-0.052758422
         9.29506246,-0.052758422 9.08487012,0.158275266 L0.157644259,9.12123435
         C-0.0525480865,9.33226804 -0.0525480865,9.67071829
         0.157644259,9.88175198 L9.08487012,18.8407293 C9.18798334,18.9442553
         9.32678961,19 9.46162998,19 C9.59647035,19 9.73527662,18.948237
         9.83838985,18.8407293 C10.0485822,18.6296956 10.0485822,18.2912454
         9.83838985,18.0802117 L1.29585564,9.49950228 Z"}]]]]]])

(defn arrow-left []
  [:svg
   {:version "1.1", :viewBox "0 0 10 19", :height "19px", :width "10px"}
   [:g
    {:fill-rule "evenodd"
     :fill "none"
     :stroke-width "1"
     :stroke "none"}
    [:g
     {:fill-rule "nonzero"
      :fill "#000000"
      :transform "translate(-644.000000, -439.000000)"}
     [:g
      {:transform "translate(633.000000, 431.000000)"}
      [:g
       {:transform "translate(11.000000, 8.000000)"}
       [:path
        {:d
         "M1.29585564,9.49950228 L9.84235574,0.918792896 C10.0525481,0.707759208
         10.0525481,0.369308954 9.84235574,0.158275266 C9.63216339,-0.052758422
         9.29506246,-0.052758422 9.08487012,0.158275266 L0.157644259,9.12123435
         C-0.0525480865,9.33226804 -0.0525480865,9.67071829
         0.157644259,9.88175198 L9.08487012,18.8407293 C9.18798334,18.9442553
         9.32678961,19 9.46162998,19 C9.59647035,19 9.73527662,18.948237
         9.83838985,18.8407293 C10.0485822,18.6296956 10.0485822,18.2912454
         9.83838985,18.0802117 L1.29585564,9.49950228 Z"}]]]]]])

#_{:clj-kondo/ignore [:clojure-lsp/unused-public-var]}
(defn favorite [stroked?]
  [:svg
   {:version "1.1", :viewBox "0 0 26 23", :height "23px", :width "26px"}
   [:g
    {:fill-rule "evenodd"
     :fill "none"
     :stroke-width "1"
     :stroke "none"}
    [:g.heart
     {:stroke-width "2"
      :stroke "#fd5656"
      :fill (if stroked? "transparent" "#fd5656")
      :transform "translate(2.000000, 2.000000)"}
     [:path
      {:d
       "M11,19 C11.04,19.06 0,13.3 0,5.82 C0.0132044942,4.26316141
       0.644348986,2.77533881 1.75457669,1.68386495 C2.8648044,0.592391091
       4.36316237,-0.0133174497 5.92,0 C7.99087864,-0.00669390896
       9.91575725,1.0656302 11,2.83 C12.0842428,1.0656302
       14.0091214,-0.00669390896 16.08,-1.13686838e-13 C19.35,-1.13686838e-13
       22,2.6 22,5.82 C22,13.3 11,19 11,19 L11,19 Z"}]]]])

(defn mf-supersign-white []
  [:svg
   {:xmlSpace "preserve"
    :viewBox "0 0 27.87 19.6"
    :y "0px"
    :x "0px"
    :version "1.1"}
   [:style
    {:type "text/css"}
    ".st0{opacity:0.4;fill:#FFFFFF;}.st1{fill:#FFFFFF;}\n\t.st2{fill:none;}\n"]
   [:g
    [:g
     [:path.st0
      {:d
       "M13.55,16.05c0.25-0.03,0.45-0.06,0.66-0.15c0.69-0.31,1.02-0.98,1.19-1.47c0.41-1.45,2.72-9.47,2.72-9.49
       c0.45-1.57,2.09-2.48,3.66-2.03c0.42,0.12,0.79,0.33,1.11,0.6c0,0,0,0,0,0c0,0,0,0,0,0
       c-0.25,0.03-0.44,0.06-0.66,0.15c-0.69,0.31-1.02,0.98-1.19,1.47c-0.41,1.45-2.72,9.47-2.72,9.49
       c-0.45,1.57-2.08,2.47-3.66,2.03C14.23,16.53,13.86,16.32,13.55,16.05C13.55,16.05,13.55,16.05,13.55,16.05z"}]
     [:path.st0
      {:d
       "M5.01,16.05c0.25-0.03,0.44-0.06,0.66-0.16c0.69-0.31,1.02-0.98,1.19-1.47c0.41-1.45,2.72-9.45,2.72-9.47
       c0.45-1.57,2.07-2.47,3.66-2.03c0.42,0.12,0.8,0.33,1.11,0.6c0,0,0,0,0,0c0,0,0,0,0,0
       c-0.25,0.03-0.45,0.06-0.66,0.15C13,3.98,12.67,4.65,12.5,5.15c-0.41,1.45-2.72,9.45-2.72,9.47
       c-0.45,1.57-2.07,2.47-3.66,2.03 C5.7,16.53,5.33,16.32,5.01,16.05 C5.01,16.05,5.01,16.05,5.01,16.05z"}]
     [:path.st1
      {:d
       "M8.17,16.5c-0.23-0.1-0.41-0.18-0.59-0.33C7,15.68,6.87,14.95,6.85,14.42c0-1.51,0.01-11.33,0.01-11.33H4
       c0,0-0.01,10.69-0.01,10.71c0,1.63,1.32,2.96,2.96,2.96C7.38,16.76,7.8,16.67,8.17,16.5
       C8.17,16.5,8.17,16.5,8.17,16.5 C8.17,16.5,8.17,16.5,8.17,16.5z"}]
     [:path.st1
      {:d
       "M16.7,16.49c-0.23-0.1-0.41-0.18-0.59-0.33c-0.58-0.48-0.71-1.22-0.74-1.74c0-1.51,0.01-8.64,0.01-8.66
       c0-1.63-1.32-2.96-2.96-2.96c-0.44,0-0.86,0.1-1.23,0.27c0,0,0,0,0,0c0,0,0,0,0,0c0.23,0.1,0.41,0.18,0.59,0.33
       c0.58,0.48,0.71,1.22,0.74,1.74c0,1.51-0.01,8.64-0.01,8.66c0,1.63,1.32,2.96,2.96,2.96
       C15.91,16.76,16.33,16.67,16.7,16.49 C16.7,16.5,16.7,16.5,16.7,16.49C16.7,16.5,16.7,16.5,16.7,16.49z"}]
     [:path.st1
      {:d
       "M19.73,3.07c0.23,0.1,0.41,0.18,0.59,0.33c0.58,0.48,0.71,1.22,0.74,1.74c0,1.51-0.01,11.32-0.01,11.32h2.86
       c0,0,0.01-10.69,0.01-10.71c0-1.63-1.32-2.96-2.96-2.96C20.52,2.8,20.1,2.89,19.73,3.07
       C19.73,3.07,19.73,3.07,19.73,3.07 C19.73,3.07,19.73,3.07,19.73,3.07z"}]]]
   [:rect.st2 {:height "19.6", :width "27.87"}]])

(defn mf-rib-background []
  [:div.bg-cover
   [:svg
    {:version "1.1"
     :viewBox "0 0 1920 1079"
     :height "1079px"
     :width "1920px"
     :preserveAspectRatio "xMidYMin slice"}
    [:g
     {:opacity "0.4"
      :fill-rule "evenodd"
      :fill "none"
      :stroke-width "1"
      :stroke "none"}
     [:g
      {:fill-rule "nonzero"
       :fill "#FFFFFF"
       :transform "translate(-246.000000, -391.000000)"}
      [:path
       {:opacity "0.4"
        :d
        "M1566.7,1577.8 C1584.5,1560.1 1598.3,1545.3 1609.3,1524.4
        C1644.9,1457.2 1629,1383.4 1611.5,1333.5 C1553.8,1192.7 1235.8,413.5
        1235,411.6 C1172.7,259.1 1245.9,84.9 1398.4,22.6 C1439.4,5.9 1482,-0.8
        1523.6,1 C1523.7,1 1523.7,1 1523.8,1 C1523.8,1 1523.8,1 1523.8,1
        C1506,18.7 1492.2,33.2 1481.1,54.1 C1445.5,121.3 1461.4,195.1 1478.9,245
        C1536.6,385.8 1854.6,1165 1855.3,1166.9 C1917.6,1319.4 1844.3,1492.3
        1691.9,1555.9 C1651,1573 1608.3,1579.6 1566.8,1577.9 C1566.8,1577.8
        1566.7,1577.8 1566.7,1577.8 Z"}]
      [:path
       {:opacity "0.4"
        :d
        "M890.2,2110.4 C908,2092.7 921.6,2077.9 932.6,2057 C968.2,1989.8
        952.3,1916 934.8,1866.1 C877.1,1725.3 560,947.2 559.2,945.3 C496.9,792.8
        569.4,620.3 722.6,556.3 C763.5,539.2 806.2,532.6 847.7,534.3
        C847.8,534.3 847.8,534.3 847.9,534.3 C847.9,534.3 847.9,534.3
        847.9,534.3 C830.1,552 816.3,566.8 805.3,587.7 C769.7,654.9 785.6,728.7
        803.1,778.6 C860.8,919.4 1177.9,1697.5 1178.7,1699.4 C1241,1851.9
        1169.1,2024 1015.3,2088.4 C974.5,2105.5 931.8,2112.1 890.2,2110.4
        C890.2,2110.4 890.2,2110.4 890.2,2110.4 Z"}]
      [:path
       {:d
        "M1168.3,1948.4 C1144.2,1955.2 1124.5,1959.8 1100.8,1959.1
        C1024.8,1956.9 968.5,1906.7 933.7,1866.8 C839.7,1747.1 227.3,968.6
        227.3,968.6 L0.9,1146.9 C0.9,1146.9 667.1,1995.1 668.4,1996.7
        C770.3,2126.2 957.9,2148.5 1087.4,2046.6 C1122.2,2019.2 1149.3,1985.6
        1168.2,1948.6 C1168.3,1948.5 1168.3,1948.4 1168.3,1948.4 C1168.3,1948.4
        1168.3,1948.4 1168.3,1948.4 Z"}]
      [:path
       {:d
        "M1844.6,1415.8 C1820.5,1422.6 1800.8,1427.2 1777.1,1426.5
        C1701.1,1424.3 1644.8,1374.1 1610,1334.2 C1516,1214.5 1071.7,649.2
        1070.4,647.6 C968.5,518.1 780.9,495.8 651.4,597.7 C616.6,625.1
        589.5,658.7 570.6,695.7 C570.6,695.8 570.5,695.8 570.5,695.9
        C570.5,695.9 570.5,695.9 570.5,695.9 C594.6,689.1 614.3,684.5 638,685.2
        C714,687.4 770.3,737.6 805.1,777.5 C899.1,897.2 1343.4,1462.5
        1344.7,1464.1 C1446.6,1593.6 1634.2,1615.9 1763.7,1514 C1798.5,1486.6
        1825.6,1453 1844.5,1416 C1844.5,1416 1844.6,1415.9 1844.6,1415.8
        C1844.6,1415.8 1844.6,1415.8 1844.6,1415.8 Z"}]
      [:path
       {:d
        "M1246,162.8 C1270.1,156 1289.8,151.4 1313.5,152.1 C1389.5,154.3
        1445.8,204.5 1480.6,244.4 C1574.6,364.1 2186.8,1142.3 2186.8,1142.3
        L2413.2,964 C2413.2,964 1747.2,116.2 1746,114.5 C1644.1,-15 1456.5,-37.3
        1327,64.6 C1292.2,92 1265.1,125.6 1246.2,162.6 C1246.1,162.7 1246,162.8
        1246,162.8 C1246,162.8 1246,162.8 1246,162.8 Z"}]]]]])

(defn header-profile []
  [:svg {:width "30px"
         :height "30px"
         :viewBox "0 0 24 24"
         :version "1.1"}
   [:g {:stroke "none"
        :stroke-width "1"
        :fill "none"
        :fill-rule "evenodd"
        :stroke-linecap "round"
        :stroke-linejoin "round"}
    [:g {:stroke "#122020"
         :stroke-width "1.25"}
     [:g {:transform "translate(3.000000, 2.000000)"}
      [:path {:d
              "M4.625,5 C4.625,7.41624578 6.58375422,9.375 9,9.375 C11.4162458,9.375 13.375,7.41624578 13.375,5
              C13.375,2.58375422 11.4162458,0.625 9,0.625 C6.58375422,0.625 4.625,2.58375422 4.625,5 Z"}]
      [:path {:d
              "M5.23,2.77833333 C6.59861942,4.19837412 8.48611763,5.00042548 10.4583333,5.00000057
              C11.4470205,5.00039197 12.4253623,4.7987685 13.3333333,4.4075"}]
      [:path {:d
              "M0.875,19.375 C0.875,14.8876864 4.51268641,11.25 9,11.25 C13.4873136,11.25
              17.125,14.8876864 17.125,19.375"}]
      [:path {:d
              "M5.875,11.8741667 L5.875,12.5 C5.875,14.2258898 7.27411016,15.625 9,15.625
              C10.7258898,15.625 12.125,14.2258898 12.125,12.5 L12.125,11.8741667"}]]]]])

(defn logout []
  [:svg
   {:version "1.1" :viewBox "0 0 22 21" :height "21px" :width "22px"}
   [:g
    {:fill-rule "evenodd"
     :fill "none"
     :stroke-width "1"
     :stroke "none"}
    [:g
     {:stroke-width "1.25"
      :stroke "#000000"
      :transform "translate(1.000000, 1.000000)"}
     [:path
      {:d
       "M16.250037,14.9893942 L16.250037,16.2393942 C16.250037,16.9297502
       15.690393,17.4893942 15.000037,17.4893942 L11.250037,17.4893942"}]
     [:path
      {:d
       "M11.250037,2.48939424 L15.000037,2.48939424 C15.690393,2.48939424
       16.250037,3.0490383 16.250037,3.73939424 L16.250037,4.98939424"}]
     [:path
      {:d
       "M8.03337036,18.7310609 L0.533370359,17.6977276 C0.224392629,17.6519341 -0.00333806259,17.3850622
       -3.62233687e-05,17.0727276 L-3.62233687e-05,2.46439424 C0.00496776589,2.17458119 0.208512166,1.92618803
       0.491703693,1.86439424 L7.99170369,0.0143942384 C8.1761308,-0.0258785967 8.36887959,0.0193627951
       8.51612857,0.137485603 C8.66337755,0.255608411 8.74934901,0.433955788 8.75003703,0.622727572
       L8.75003703,18.1227276 C8.75003703,18.303724 8.67042354,18.4755597 8.53243612,18.5926886
       C8.3944487,18.7098175 8.21197111,18.7604117 8.03337036,18.7310609 Z"}]
     [:polyline
      {:points
       "16.250037 7.48939424 18.750037 9.98939424 11.875037 9.98939424"}]
     [:path {:d "M16.250037,12.4893942 L18.750037,9.98939424"}]
     [:path
      {:d
       "M5.52503703,9.04772757 C5.35014686,9.04772757 5.20837036,9.18950407 5.20837036,9.36439424
       C5.23345258,9.51748138 5.36574205,9.62986005 5.52087037,9.62986005 C5.67599867,9.62986005
       5.80828814,9.51748138 5.83337036,9.36439424 C5.83342982,9.19270742 5.6966644,9.05224564
       5.52503703,9.04772757 L5.52503703,9.04772757"}]]]])
